import axios from 'axios'

// servicios agetic
export const onObtenerValorLegalDocumentoAgeticApi = async ({ body }: {
  body: {
    idFiles: string[],
    developmentEnvironment: string,
    url: string,
    token: string,
  }
}) => {
  try {
    const resp = await axios.post('/api/v1/aprobacion/verificar',
      {
        idFiles: body.idFiles,
        developmentEnvironment: body.developmentEnvironment
      },
      {
        baseURL: body.url,
        headers: {
          Authorization: `bearer ${body.token}`
        }
      })
    return resp.data
  } catch (err: any) {
    if (err.response?.data) throw err.response.data
    throw err
  }
}

// servicio agetic - sincronizar total de aprobaciones
export const onSincronizarValorLegalDocumentoAgeticApi = async ({ body }: {
  body: {
    idFile: string,
    developmentEnvironment: string,
    url: string,
    token: string,
  }
}) => {
  try {
    const resp = await axios.post('/api/v1/aprobacion/sync-doc',
      {
        idFile: body.idFile,
        developmentEnvironment: body.developmentEnvironment
      },
      {
        baseURL: body.url,
        headers: {
          Authorization: `bearer ${body.token}`
        }
      })
    return resp.data
  } catch (err: any) {
    if (err.response?.data) throw err.response.data
    throw err
  }
}

// servicio adsib - sincronizar total de firmas
export const onSincronizarValorLegalDocumentoAdsibApi = async ({ body }: {
  body: {
    idFile: string,

    url: string,
    token: string,
  }
}) => {
  try {
    const resp = await axios.post('/adsib/sync-up-document',
      {
        document_id: body.idFile
      },
      {
        baseURL: body.url,
        headers: {
          Authorization: `bearer ${body.token}`
        }
      })
    return resp.data
  } catch (err: any) {
    if (err.response?.data) throw err.response.data
    throw err
  }
}

// servicios adsib
export const onObtenerValorLegalDocumentoAdsibApi = async ({ body }: {
  body: {
    document_ids: string[],
    url: string,
    token: string,
  }
}) => {
  try {
    const resp = await axios.post('/adsib/validate-sign-document', {
      document_ids: body.document_ids
    }, {
      baseURL: body.url,
      headers: {
        Authorization: `bearer ${body.token}`
      }
    })
    return resp.data
  } catch (err: any) {
    if (err.response?.data) throw err.response.data
    throw err
  }
}

export const onFirmarDocumentoApi = async ({ body }: {
  body: {
    document_id: String[];
    pin: string,
    token: string,
    url: string
  }
}) => {
  try {
    const resp = await axios.post('adsib/sign-document',
      {
        pin: body.pin,
        document_ids: body.document_id
      },
      {
        baseURL: body.url,
        headers: {
          Authorization: `bearer ${body.token}`
        }
      }
    )
    return resp.data
  } catch (err: any) {
    if (err.response?.data) throw err.response.data
    throw err
  }
}

// servicio seguridad
export const onGetInformationADSIBApi = async ({ body }: {
  body: {
    url: string,
    token: string,
  }
}) => {
  try {
    const resp = await axios.get('/api/v1/perfil-persona/resumen/adsib',
      {
        baseURL: body.url,
        headers: {
          Authorization: `Bearer ${body.token}`
        }
      })
    return resp.data
  } catch (err: any) {
    if (err.response?.data) throw err.response.data
    throw err
  }
}

// servicio seguridad
export const onGetInformationFilesApi = async ({ body }: {
  body: {
    msFilesIds: string[],
    url: string,
    token: string,
  }
}) => {
  try {
    const resp = await axios.post('/api/v1/ms-files/multiples/detalles',
      {
        msFilesIds: body.msFilesIds
      },
      {
        baseURL: body.url,
        headers: {
          Authorization: `Bearer ${body.token}`
        }
      })
    return resp.data
  } catch (err: any) {
    if (err.response?.data) throw err.response.data
    throw err
  }
}
